export const POLICIES_ENTITIES = "policies";
export const QUOTES_ENTITIES = "quotes";
export const CALCULATED_PRICE_ENTITIES = "calculatedPrice";
